import { HeightCacheClass } from './HeightCacheClass';
import { WidthCacheClass } from './WidthCacheClass';

export const HeightCache = new HeightCacheClass();

export const WidthCache = new WidthCacheClass();
